import Text from 'components/elements/text';
import { SeparatorVertical } from 'legacy-modules/styles';
import * as React from 'react';
import { useFormContext, useWatch } from 'react-hook-form';

import ActivityGuestDetailGroupedTable from './item-table-grouped';
import { ActivitySaleFormType } from '../../form-type';

interface Props {
  parentIndex: number;
}

export default function GroupDetailTable({ parentIndex = 0 }: Props) {
  const name = `activitySales.${parentIndex}` as const;
  const { control } = useFormContext<ActivitySaleFormType>();
  const { activitySaleGuests, isGroupedPrice } = useWatch({
    control,
    name,
  });

  if (!activitySaleGuests.length) {
    return <></>;
  }

  if (isGroupedPrice) {
    return (
      <ActivityGuestDetailGroupedTable
        parentIndex={parentIndex}
        detailIndex={0}
        isGroupedPrice={isGroupedPrice}
      />
    );
  }

  return (
    <>
      {activitySaleGuests
        .filter((curr) => !!curr.guestId)
        .map((field, idx) => (
          <React.Fragment key={field.customId}>
            <Text variant="ParagraphSmall">{field.guestName || '-'}</Text>
            <SeparatorVertical $margin={16} />
            <ActivityGuestDetailGroupedTable
              parentIndex={parentIndex}
              detailIndex={idx}
              isGroupedPrice={isGroupedPrice}
            />
            <SeparatorVertical $margin={24} />
          </React.Fragment>
        ))}
    </>
  );
}
